import { render, staticRenderFns } from "./certificate2.vue?vue&type=template&id=6ec3e4c6&scoped=true"
import script from "./certificate2.vue?vue&type=script&lang=js"
export * from "./certificate2.vue?vue&type=script&lang=js"
import style0 from "./certificate2.vue?vue&type=style&index=0&id=6ec3e4c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3e4c6",
  null
  
)

export default component.exports